import { RETREAT, RETREAT_DONE, RETREAT_START, RETREAT_UNDO, CHOOSE_BENCH_POSITION } from './constants';
import { isImmutable, fromJS, List } from 'immutable';
import { UNDO_WINDOW_MS } from './constants';

/** Starts choosing the energy to discard; with a bench position, the Pokémon to switch in is already chosen (dragged). */
export const retreatStart = (benchPosition = null) => ({
  type: RETREAT_START,
  payload: fromJS({ benchPosition }),
});

export const chooseBenchPosition = (energyAttachmentIds) => ({
  type: CHOOSE_BENCH_POSITION,
  payload: fromJS({ energyAttachmentIds: isImmutable(energyAttachmentIds) ? energyAttachmentIds : List() }),
});

/** Retreats, after UNDO_WINDOW_MS unless it's undone first. */
export const retreat = (benchPosition) => ({
  type: RETREAT,
  payload: fromJS({ benchPosition, sendsAt: Date.now() + UNDO_WINDOW_MS }),
});

export const retreatUndo = () => ({
  type: RETREAT_UNDO,
});

export const retreatDone = () => ({
  type: RETREAT_DONE,
});

